import { render, staticRenderFns } from "./EditMail.vue?vue&type=template&id=4e940a26&scoped=true"
import script from "./EditMail.vue?vue&type=script&lang=js"
export * from "./EditMail.vue?vue&type=script&lang=js"
import style0 from "./EditMail.vue?vue&type=style&index=0&id=4e940a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e940a26",
  null
  
)

export default component.exports